<template>
    <div ref="module" @animationend="animationend">
       <slot></slot>
    </div>
</template>

<script>
export default {
  // 组件名称
  name: 'animateModule',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      ob: new IntersectionObserver(this.obRef, {
        threshold: 0,
        root: null
      })
    }
  },
  mounted() {
    if (!this.disabled) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.ob.observe(this.$refs.module)
        }, 100);
      })
    }
  },
  beforeUnmount() {
    this.ob.unobserve(this.$refs.module)
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    obRef(entries) {
      for (const item of entries) {
        const isIntersecting = item.isIntersecting
        const el = item.target
        if (isIntersecting) {
          el.classList.add('animate__animated', `animate__${this.config.activeAnimate}`)
        }
      }
    },
    animationend() {
      this.$emit('animationend')
    }
  }
}
</script>

<style scoped></style>
